import {Directive, TemplateRef, ViewContainerRef} from '@angular/core';
import {User} from '../models/user.model';
import {AuthService} from '../services/auth.service';
import {ROLE} from '../const/mock-selectize-config';

/**
 * Add the template content to the DOM unless the condition is true.
 */
@Directive({selector: '[isEmployer]'})
export class IsEmployerDirective {
  private hasView?: boolean;
  private user: User;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService) {

    this.authService.getAuth().subscribe((auth) => {
      this.user = auth.user;
      this.checkEmployer(this.user);
    });
  }

  private checkEmployer(user: User) {
    if (user) {
      for (let r of user.role) {
        if (r.name == ROLE.employer || r.name == ROLE.superAdmin || r.name == ROLE.admin && !this.hasView) {
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.hasView = true;
          return;
        } else if ((r.name != ROLE.employer || r.name != ROLE.superAdmin || r.name == ROLE.admin) && this.hasView) {
          this.viewContainer.clear();
          this.hasView = false;
        }
      }
    }
  }
}
